module.exports = __webpack_public_path__ + "static/media/seal.3e8dde9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/ID/seal.svg
// module id = 1079
// module chunks = 0